module.exports = __webpack_public_path__ + "static/media/ic_vimeo.8a7b14b7.svg";